package com.solevo.dist.theme

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.rgb
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.rgba

/**
 * Created by Ilija Vucetic on 13.9.25..
 * Copyright (c) 2025 Aktiia. All rights reserved.
 */
enum class SLColors(
    val hex: String,
    val rgb: Color.Rgb
) {
    Primary(
        hex = "#00A2FF",
        rgb = rgb(r = 0, g = 162, b = 255)
    ),
    Secondary(
        hex = "#001019",
        rgb = rgb(r = 0, g = 16, b = 25)
    ),
    Tertiary(
        hex = "#001925",
        rgb = rgb(r = 0, g = 25, b = 37)
    ),
    LightGrayUltra(
        hex = "##DDE2E4",
        rgb = rgb(221, 226, 228)
    ),
    LightGray(
        hex = "#D9D9D9",
        rgb = rgb(217, 217, 217)
    ),
    Gray(
        hex = "#E9E9E9",
        rgb = rgb(r = 233, g = 233, b = 233)
    ),
    DarkGray(
        hex = "#252C32",
        rgb = rgb(r = 37, g = 44, b = 50)
    ),
    HalfWhite(
        hex = "#FFFFFF",
        rgb = rgba(r = 255, g = 255, b = 255, a = 0.5f)
    ),
    HalfBlack(
        hex = "#000000",
        rgb = rgba(r = 0, g = 0, b = 0, a = 0.5f)
    ),
    White(
        hex = "#FFFFFF",
        rgb = rgb(r = 255, g = 255, b = 255)
    ),
    Green(
        hex = "#00FF94",
        rgb = rgb(r = 0, g = 255, b = 148)
    ),
    Yellow(
        hex = "#FFEC45",
        rgb = rgb(r = 255, g = 236, b = 69)
    ),
    Red(
        hex = "#FF6359",
        rgb = rgb(r = 255, g = 99, b = 89)
    ),
    Purple(
        hex = "#8B6DFF",
        rgb = rgb(r = 139, g = 109, b = 255)
    ),
    Sponsored(
        hex = "#3300FF",
        rgb = rgb(r = 51, g = 0, b = 255)
    )
}

val textPrimaryColor = rgba(r = 37, g = 44, b = 50, a = 1f)

// Primary button colors
val btnPrimaryColor = rgba(r = 15, g = 103, b = 234, a = 1.0f)
val btnPrimaryHoverColor = rgba(r = 10, g = 80, b = 200, a = 1.0f)
val btnPrimaryDisabledColor = rgba(r = 180, g = 210, b = 250, a = 1.0f)
val btnPrimaryTextColor = rgb(r = 255, g = 255, b = 255)
